
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/enterprise-applications",
      function () {
        return require("private-next-pages/services/enterprise-applications.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/enterprise-applications"])
      });
    }
  